import React from 'react';

export default function FlexRow({ className, children, ...rest }) {
  return (
    <div className={`flex flex-row ${className}`} {...rest}>
      {children}
    </div>
  );
}
